<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.34375 7.53125C2.34375 16.1607 9.3393 23.1562 17.9688 23.1562H20.3125C21.6069 23.1562 22.6562 22.1069 22.6562 20.8125V19.3837C22.6562 18.846 22.2903 18.3773 21.7686 18.2468L17.1611 17.095C16.7037 16.9806 16.2223 17.1515 15.9394 17.5287L14.9288 18.8762C14.6354 19.2673 14.1281 19.4403 13.6691 19.2721C10.2244 18.0103 7.48974 15.2756 6.22788 11.8309C6.05973 11.3719 6.23267 10.8646 6.62375 10.5712L7.97127 9.56061C8.34847 9.27771 8.51939 8.79631 8.40503 8.33889L7.25316 3.7314C7.12274 3.20972 6.65401 2.84375 6.11628 2.84375H4.6875C3.39308 2.84375 2.34375 3.89308 2.34375 5.1875V7.53125Z"
                :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgPhoneEmpty',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>